export enum SUPPORT_EMAIL_FE_BE_MAPPING_FIELD {
    id = 'id',
    name = 'name',
    email = 'email',
    emails = 'emails',

}
export class SupportEmail {
    id: number;
    name: string;
    emails: ItemSupportEmail[];

    constructor(params: any = {}, parsed: boolean = true) {

        if (parsed) {
            this.parseFromResp(params);
        } else {
            this.id = params.id;
            this.name = params.name;
            this.emails = (params.emails || []).map((item) => new ItemSupportEmail(item, false));
        }
    }

    parseFromResp(respObject: any = {}) {
        this.id = respObject[SUPPORT_EMAIL_FE_BE_MAPPING_FIELD.id];
        this.name = respObject[SUPPORT_EMAIL_FE_BE_MAPPING_FIELD.name];
        this.emails = (respObject[SUPPORT_EMAIL_FE_BE_MAPPING_FIELD.emails] || [])
        .map((item) => {
            return new ItemSupportEmail(item);
        });
        return this;
    }

    convertToReqBody() {
        const body = {};
        body[SUPPORT_EMAIL_FE_BE_MAPPING_FIELD.id] = this.id;
        body[SUPPORT_EMAIL_FE_BE_MAPPING_FIELD.name] = this.name;
        body[SUPPORT_EMAIL_FE_BE_MAPPING_FIELD.emails] = this.emails
        .map((item: ItemSupportEmail) => {
            const itemBody = item.convertToReqBody();
            return itemBody;
        });
        return body;

    }
}
export class ItemSupportEmail {
    id: number;
    name: string;
    email: string;

    constructor(params: any = {}, parsed: boolean = true) {
        if (parsed) {
            this.parseFromResp(params);
        } else {
            this.id = params.id;
            this.name = params.name;
            this.email = params.email;
        }
    }

    parseFromResp(respObject: any = {}) {
        this.id = respObject[SUPPORT_EMAIL_FE_BE_MAPPING_FIELD.id];
        this.name = respObject[SUPPORT_EMAIL_FE_BE_MAPPING_FIELD.name];
        this.email = respObject[SUPPORT_EMAIL_FE_BE_MAPPING_FIELD.email];
        return this;
    }

    convertToReqBody() {
        const body = {};
        body[SUPPORT_EMAIL_FE_BE_MAPPING_FIELD.id] = this.id;
        body[SUPPORT_EMAIL_FE_BE_MAPPING_FIELD.email] = this.email || '';
        body[SUPPORT_EMAIL_FE_BE_MAPPING_FIELD.name] = this.name || '';
        return body;

    }
}
